import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

import Stepper from '../../components/Stepper/Stepper';
import PlanDetail from '../../components/PlanDetail/PlanDetail';
import AskButton from '../../components/AskButton/AskButton';
import BackButton from '../../components/BackButton/BackButton';

class StepFour extends Component {
  componentDidMount() {
    if(process.env.PUBLIC_URL) {
      const pathname = `${process.env.PUBLIC_URL}/step4`;
      ReactGA.pageview(pathname);
    }
  }
  render() {
    if (!(this.props.location && this.props.location.state)) {
      this.props.history.push({ pathname: `${process.env.PUBLIC_URL}/step1` });
      return null;
    }

    const stepNumber = 4;
    const {
      plan,
      selectedFirst,
      selectedSecond,
      currentService,
      areaCode,
    } = this.props.location.state;

    if (!plan) {
      this.props.history.push({ pathname: `${process.env.PUBLIC_URL}/step1` });
      return null;
    }

    const handleBack = () => this.props.history.goBack();

    const createUri = () => {
      const optionsFirst = [ '一戸建て', '集合住宅' ];
      const optionsSecond = [ '持ち家', '賃貸' ];
      const areas = [ '松任エリア', '鶴来エリア', '美川エリア', '白山麓エリア' ];
      const currentOptions = [ '利用している', '利用していない' ];
      const {
        tvCourse,
        internetCourse,
        phoneCourse,
        discountPrice,
        discountPriceWithTax
      } = plan;

      const home = `住居タイプ：${optionsFirst[selectedFirst[0]]}${selectedSecond.length ? ` ${optionsSecond[selectedSecond[0]]}` : ''}`;
      const area = `エリア：${areas[areaCode]}`;
      const current = `利用：${currentOptions[currentService[0]]}`;
      const tv = `テレビ：${tvCourse !== '0' ? tvCourse : 'なし'}`;
      const internet = `インターネット：${internetCourse !== '0' ? internetCourse : 'なし'}`;
      const phone = `でんわ：${phoneCourse !== '0' ? phoneCourse : 'なし'}`;
      const border = '=====';
      const price = `合計金額：${discountPrice}円（税込 ${discountPriceWithTax}円）`;
      const br = encodeURIComponent('\n');

      const clean = value => {
          if (!value) return value;
          return value.replace(/\s+/g, '')
      };

      const textItems = [
        home,
        area,
        current,
        tv,
        internet,
        phone,
        border,
        price,
      ]

      let text = '';
      textItems.map((item, index) => {
        text = text + encodeURIComponent(clean(item))
        if (index !== textItems.length - 1)
         text = text + br;
        return text;
      });

      const baseUri = 'http://asagaotv.jp/';
      const path = 'inquiry-form/contact/';
      const query = `inquiry=${text}`;
      const uri = `${baseUri}${path}?${query}`
      return uri;
    }

    return (
      <div id="container" className="container StepFourContainer" >
        <Stepper activeNumber={stepNumber} />
        <PlanDetail
          plan={plan}
        />
        <AskButton
          uri={createUri()}
        />
        <BackButton onClick={handleBack} />
      </div>
    );
  }
};

export default withRouter(StepFour);
